import { render, staticRenderFns } from "./routine-V2.vue?vue&type=template&id=499e0bf6"
import script from "./routine-V2.vue?vue&type=script&lang=js"
export * from "./routine-V2.vue?vue&type=script&lang=js"
import style0 from "./routine.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports